import {List} from "immutable";
import {enforestExpr, Enforester} from "./enforester";
import TermExpander from "./term-expander.js";
import BindingMap from "./binding-map.js";
import Env from "./env";
import Reader from "./shift-reader";
import  * as _ from "ramda";
import Term, {isEOF, isBindingIdentifier, isBindingPropertyProperty, isBindingPropertyIdentifier, isObjectBinding, isArrayBinding, isFunctionDeclaration, isFunctionExpression, isFunctionTerm, isFunctionWithName, isSyntaxDeclaration, isSyntaxrecDeclaration, isVariableDeclaration, isVariableDeclarationStatement, isImport, isExport} from "./terms";
import {Maybe} from "ramda-fantasy";
import {gensym} from "./symbol";
import {VarBindingTransform, CompiletimeTransform} from "./transforms";
import {expect, assert} from "./errors";
import loadSyntax from "./load-syntax";
import {Scope, freshScope} from "./scope";
const Just_890 = Maybe.Just;
const Nothing_891 = Maybe.Nothing;
const registerSyntax_892 = (stx_897, context_898) => {
  let newBinding_899 = gensym(stx_897.val());
  context_898.env.set(newBinding_899.toString(), new VarBindingTransform(stx_897));
  context_898.bindings.add(stx_897, {binding: newBinding_899, phase: 0, skipDup: true});
};
let registerBindings_893 = _.cond([[isBindingIdentifier, ({name}, context_900) => {
  registerSyntax_892(name, context_900);
}], [isBindingPropertyIdentifier, ({binding}, context_901) => {
  registerBindings_893(binding, context_901);
}], [isBindingPropertyProperty, ({binding}, context_902) => {
  registerBindings_893(binding, context_902);
}], [isArrayBinding, ({elements, restElement}, context_903) => {
  if (restElement != null) {
    registerBindings_893(restElement, context_903);
  }
  elements.forEach(el_904 => {
    if (el_904 != null) {
      registerBindings_893(el_904, context_903);
    }
  });
}], [isObjectBinding, ({properties}, context_905) => {}], [_.T, binding_906 => assert(false, "not implemented yet for: " + binding_906.type)]]);
let removeScope_894 = _.cond([[isBindingIdentifier, ({name}, scope_907) => new Term("BindingIdentifier", {name: name.removeScope(scope_907)})], [isArrayBinding, ({elements, restElement}, scope_908) => {
  return new Term("ArrayBinding", {elements: elements.map(el_909 => el_909 == null ? null : removeScope_894(el_909, scope_908)), restElement: restElement == null ? null : removeScope_894(restElement, scope_908)});
}], [isBindingPropertyIdentifier, ({binding, init}, scope_910) => new Term("BindingPropertyIdentifier", {binding: removeScope_894(binding, scope_910), init: init})], [isBindingPropertyProperty, ({binding, name}, scope_911) => new Term("BindingPropertyProperty", {binding: removeScope_894(binding, scope_911), name: name})], [isObjectBinding, ({properties}, scope_912) => new Term("ObjectBinding", {properties: properties.map(prop_913 => removeScope_894(prop_913, scope_912))})], [_.T, binding_914 => assert(false, "not implemented yet for: " + binding_914.type)]]);
function findNameInExports_895(name_915, exp_916) {
  let foundNames_917 = exp_916.reduce((acc_918, e_919) => {
    if (e_919.declaration) {
      return acc_918.concat(e_919.declaration.declarators.reduce((acc_920, decl_921) => {
        if (decl_921.binding.name.val() === name_915.val()) {
          return acc_920.concat(decl_921.binding.name);
        }
        return acc_920;
      }, List()));
    }
    return acc_918;
  }, List());
  assert(foundNames_917.size <= 1, "expecting no more than 1 matching name in exports");
  return foundNames_917.get(0);
}
function bindImports_896(impTerm_922, exModule_923, context_924) {
  let names_925 = [];
  impTerm_922.namedImports.forEach(specifier_926 => {
    let name_927 = specifier_926.binding.name;
    let exportName_928 = findNameInExports_895(name_927, exModule_923.exportEntries);
    if (exportName_928 != null) {
      let newBinding = gensym(name_927.val());
      context_924.bindings.addForward(name_927, exportName_928, newBinding);
      if (context_924.store.has(exportName_928.resolve())) {
        names_925.push(name_927);
      }
    }
  });
  return List(names_925);
}
export default class TokenExpander {
  constructor(context_929) {
    this.context = context_929;
  }
  expand(stxl_930) {
    let result_931 = List();
    if (stxl_930.size === 0) {
      return result_931;
    }
    let prev_932 = List();
    let enf_933 = new Enforester(stxl_930, prev_932, this.context);
    let self_934 = this;
    while (!enf_933.done) {
      let term = _.pipe(_.bind(enf_933.enforest, enf_933), _.cond([[isVariableDeclarationStatement, term_935 => {
        term_935.declaration.declarators = term_935.declaration.declarators.map(decl_936 => {
          return new Term("VariableDeclarator", {binding: removeScope_894(decl_936.binding, self_934.context.useScope), init: decl_936.init});
        });
        if (isSyntaxDeclaration(term_935.declaration)) {
          let scope = freshScope("nonrec");
          term_935.declaration.declarators.forEach(decl_937 => {
            let name_938 = decl_937.binding.name;
            let nameAdded_939 = name_938.addScope(scope);
            let nameRemoved_940 = name_938.removeScope(self_934.context.currentScope[self_934.context.currentScope.length - 1]);
            let newBinding_941 = gensym(name_938.val());
            self_934.context.bindings.addForward(nameAdded_939, nameRemoved_940, newBinding_941);
            decl_937.init = decl_937.init.addScope(scope, self_934.context.bindings);
          });
        }
        if (isSyntaxDeclaration(term_935.declaration) || isSyntaxrecDeclaration(term_935.declaration)) {
          term_935.declaration.declarators.forEach(decl_942 => {
            registerBindings_893(decl_942.binding, self_934.context);
            loadSyntax(decl_942, self_934.context, self_934.context.env);
          });
          return Nothing_891();
        } else {
          term_935.declaration.declarators.forEach(decl_943 => registerBindings_893(decl_943.binding, self_934.context));
        }
        return Just_890(term_935);
      }], [isFunctionWithName, term_944 => {
        term_944.name = removeScope_894(term_944.name, self_934.context.useScope);
        registerBindings_893(term_944.name, self_934.context);
        return Just_890(term_944);
      }], [isImport, term_945 => {
        let mod_946 = self_934.context.modules.load(term_945.moduleSpecifier.val(), self_934.context);
        if (term_945.forSyntax) {
          console.log("import for syntax is not implemented yet");
        } else {
          mod_946.visit(self_934.context);
        }
        let boundNames_947 = bindImports_896(term_945, mod_946, self_934.context);
        if (boundNames_947.size === 0) {
          return Just_890(term_945);
        }
        return Nothing_891();
      }], [isEOF, Nothing_891], [_.T, Just_890]]), Maybe.maybe(List(), _.identity))();
      result_931 = result_931.concat(term);
    }
    return result_931;
  }
}
